import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCategoryStore = defineStore('category', () => {
  const categories = ref([])
  const setCategories = (cats) => {
    categories.value = cats
  }

  return {
    categories,
    setCategories
  }
})
